interface ISettings {
  title: string // 覆盖默认标题

  showSettings: boolean // 控制设置面板显示
  showTagsView: boolean // 控件tagsview显示
  showSidebarLogo: boolean // 控件siderbarlogo显示
  fixedHeader: boolean // 如果为true，将固定头组件
  errorLog: string[]
  sidebarTextTheme: boolean // 如果为true，将根据主题更改侧边栏的文本颜色
  devServerPort: number
  mockServerPort: number
}

// You can customize below settings :)
const settings: ISettings = {
  title: '课题管理系统',
  showSettings: false,
  showTagsView: false,
  fixedHeader: true,
  showSidebarLogo: true,
  errorLog: ['production'],
  sidebarTextTheme: true,
  devServerPort: 8001,
  mockServerPort: 9528
}

export default settings
